<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M23.478,11.478H20.87V.522A.522.522,0,0,0,20.348,0H3.652A.522.522,0,0,0,3.13.522V11.478H.522a.522.522,0,1,0,0,1.043H3.13V23.478A.522.522,0,0,0,3.652,24h16.7a.521.521,0,0,0,.522-.522V12.522h2.609a.522.522,0,0,0,0-1.043Zm-3.652,0H17.739V1.043h2.087Zm-3.13-7.3H7.3V1.043H16.7ZM7.3,5.217h4.174v6.261H7.3Zm4.174,7.3v6.261H7.3V12.522ZM7.3,19.826H16.7v3.13H7.3ZM16.7,18.783H12.522V12.522H16.7Zm-4.174-7.3V5.217H16.7v6.261ZM4.174,1.043H6.261V11.478H4.174Zm0,11.478H6.261V22.957H4.174ZM19.826,22.957H17.739V12.522h2.087Zm0,0"
      fill="#777"
    />
  </svg>
</template>
